import { getThemePageTypeName } from './ThemePageType';
import IContent from '@episerver/spa-core/dist/Models/IContent';
import { Icon, JordskifterettIcon, LagmannsrettIcon, TingrettIcon, Typography } from '@norges-domstoler/dds-components';
import { Helmet } from '@dr.pogodin/react-helmet';
import { General, useTranslation } from 'app/hooks/useTranslations';
import { BannerInfo } from 'app/Models/Interfaces/Banner/BannerInfo';
import { CourtType } from 'app/Models/Enums/domstolType';
import Link from 'app/Components/Shared/Link/link';
import './Banner.scss';
import { useEpiserver } from '@episerver/spa-core';

export type BannerProps = {
    iContent: IContent;
    heading: string;
    bannerInfo: BannerInfo;
};

export const Banner = ({ bannerInfo, iContent, heading }: BannerProps) => {
    const { t } = useTranslation();
    const context = useEpiserver();
    const { bannerName, bannerType, domstolType, mainPageLink } = bannerInfo;

    const helmetText = t(`${General}.NorwegianCourts`, iContent.language.name);
    const pageName = heading ? heading : iContent?.name?.toString();

    const MetaTags = (
        <title>
            {pageName} - {bannerName} {helmetText ? ' | ' + helmetText : ''}
        </title>
    );

    if (!bannerName) {
        return null;
    }

    return (
        <>
            <div className="container">
                <div className={`domstol-banner-container ${getThemePageTypeName(bannerType)}`}>
                    {mainPageLink ? (
                        <Link href={mainPageLink} className="banner-main-link">
                            <CourtTypeIcon courtType={domstolType} />
                            <Typography typographyType="bodyMedium" as="p">
                                {bannerName}
                            </Typography>
                        </Link>
                    ) : (
                        <>
                            <CourtTypeIcon courtType={domstolType} />
                            <Typography typographyType="bodyMedium" as="p">
                                {bannerName}
                            </Typography>
                        </>
                    )}
                </div>
            </div>
            {context?.isServerSideRendering() ? <Helmet>{MetaTags}</Helmet> : MetaTags}
        </>
    );
};

export default Banner;

type CourtTypeIconProps = {
    courtType?: CourtType;
};

const CourtTypeIcon = ({ courtType }: CourtTypeIconProps) => {
    if (!courtType) {
        return null;
    }

    if (courtType === CourtType.Tingrett) {
        return <Icon color="white" icon={TingrettIcon} iconSize="medium" />;
    }

    if (courtType === CourtType.Lagmannsrett) {
        return <Icon color="white" icon={LagmannsrettIcon} iconSize="medium" />;
    }

    if (courtType === CourtType.Jordskifterett) {
        return <Icon color="white" icon={JordskifterettIcon} iconSize="medium" />;
    }

    return null;
};
